import { EXPLORE_ROUTES } from "../homeDashboard/exploreRoutes";
import { DASHBOARD_ROUTES } from "../homeDashboard/dashboardRoutes";
import { AUTH_ROUTES } from "./authRoutes";
import { SETTINGS_ROUTES } from "../settingProfile/settingsRoutes";
import { GAMIFICATION_ROUTES } from "../homeDashboard/gamification/gamificationRoutes";
import { AI_TUTOR_ROUTES } from "../homeDashboard/voiceChat/aiTutorRoutes";
import { EXAM_COURSE_ROUTES } from "../homeDashboard/courses/examCourseRoutes";
import { QUIZ_ROUTES } from "../homeDashboard/quizzes/quizRoutes";
import { QUESTION_BANK_ROUTES } from "../questionBank/questionBankRoutes";
import { SEARCH_ROUTES } from "../homeDashboard/search/searchRoutes";
import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, NavDropdown, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavbarContent } from '../hooks/useNavbarContent';
import { useDynamicStyles } from '../hooks/useDynamicStyles';
import fallbackLogo from '../assets/images/logo.png';
import GoogleTranslate from './GoogleTranslate';
import { CONTENT_ROUTES } from "../homeDashboard/contentRoutes";
 
const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { data: navbarData, isLoading } = useNavbarContent();
 
  // Initialize dynamic styles
  useDynamicStyles();
 
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
 
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
 
  const handleToggle = () => {
    setMenuOpen((prev) => !prev);
  };
 
  const handleInPageLink = (e, sectionId) => {
    if (window.location.pathname === '/') {
      e.preventDefault();
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      const section = document.getElementById(sectionId);
      if (section) {
        const offsetTop = section.offsetTop - headerHeight;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    }
  };
 
//  Check if we're on the sign-in page
const authPages = [AUTH_ROUTES.signIn, AUTH_ROUTES.signUp, AUTH_ROUTES.verification, AUTH_ROUTES.forgotPassword, AUTH_ROUTES.checkEmail, AUTH_ROUTES.newPassword, "/choose-states", "/exam-categories", "/favorite-exam", "/edit-profile", "/profile", "/edit-profile"];
const isAuthPage = authPages.includes(window.location.pathname);
const hiddenHeaderPaths = new Set([
  DASHBOARD_ROUTES.home,
  EXPLORE_ROUTES.states,
  EXPLORE_ROUTES.exams,
  "/question-bank",
  "/topics",
  "/sub-topics",
  "/subject-name",
  "/question-list",
  "/questions",
  "/quizzes-pages",
  "/quiz-attempts",
  "/testquiz-instruction",
  "/test-quantitative-aptitude",
  QUIZ_ROUTES.answerSheet,
  "/rank-list",
  "/view-test-series",
  "/test-series-attempt",
  "/rapid-fire",
  "/rapid-attempts",
  "/rapid-quantitative-aptitude",
  "/gamification",
  "/challenge",
  "/battle-subject",
  "/group-battle",
  "/play-with-friends",
  "/create-room",
  "/gamification-aptitude",
  "/battle-result",
  "/single-battle",
  AI_TUTOR_ROUTES.voiceChat,
  GAMIFICATION_ROUTES.coinStore,
  GAMIFICATION_ROUTES.coinHistory,
  "/my-exams",
  EXAM_COURSE_ROUTES.plans,
  "/info-updates",
  "/exam-detail",
  "/exam-cat",
  "/choose-exam",
  "/selected-exam",
  "/subscription",
  "/exam-plan",
  "/exam-plan-detail",
  "/assessment-plan",
  "/subject-plan",
  "/assessment-attempts",
  "/purchase-rapid-attempts",
  "/payment-successful",
  "/selected-subjects",
  "/subscribe-now",
  "/payment-method",
  "/flashcard",
  "/start-flashcard",
  "/still-learning-card",
  "/articles-blogs",
  "/article-detaidoubts",
  "/blog-comment",
  "/doubts",
  "/answer-doubt",
  "/subject-podcast",
  "/topic-podcast", "/question-paper-list", "/my-progress", "/dashboard/progress",
  ...Object.values(SEARCH_ROUTES),
  "/subtopic-podcast",
  CONTENT_ROUTES.podcasts,
  "/podcast-player",
  "/subject-infographics",
  "/topic-infographics",
  CONTENT_ROUTES.infographics,
  CONTENT_ROUTES.infographicDetail,
  "/short-notes",
  "/notes-topic",
  "/notes-subtopic",
  "/notes-subjectname",
  CONTENT_ROUTES.noteDetail,
  "/referral-earn",
  "/leaderboard",
  "/daily-question",
  CONTENT_ROUTES.dailyQuestionDetail,
  "/view-profile",
  SETTINGS_ROUTES.profile,
  SETTINGS_ROUTES.notifications,
  SETTINGS_ROUTES.password,
  SETTINGS_ROUTES.appLanguage,
  SETTINGS_ROUTES.contentLanguage,
  "/setting-about",
  DASHBOARD_ROUTES.preview,
  DASHBOARD_ROUTES.states,
  DASHBOARD_ROUTES.favoriteExams,
  DASHBOARD_ROUTES.examCategories,
  DASHBOARD_ROUTES.selectExams,
  EXPLORE_ROUTES.subjects,

  EXPLORE_ROUTES.topics,
  EXPLORE_ROUTES.subtopics,
  QUESTION_BANK_ROUTES.list,
  QUESTION_BANK_ROUTES.practice,
  QUESTION_BANK_ROUTES.filter,
  CONTENT_ROUTES.notes,
  EXPLORE_ROUTES.categories,
  QUIZ_ROUTES.list,
  QUIZ_ROUTES.testSeriesList,
]);
const hideHeaderOnDashboard = hiddenHeaderPaths.has(window.location.pathname)
  || window.location.pathname.startsWith(`${SEARCH_ROUTES.categories}/`);
 
if (hideHeaderOnDashboard) return null;
 
  return (
    <header
    id="header"
    className={`${isScrolled ? "scrolled" : ""} ${
      isAuthPage ? "header-signin" : ""
    }`}
  >
      <Container>
        <Navbar expand="lg" variant="light" sticky="top" className="p-0">
          <Navbar.Brand as={Link} to="/">
            <img
              src={navbarData?.dataset?.data?.logo || fallbackLogo}
              alt="Logo"
              className="navbar-logo"
              onError={(e) => {
                e.target.src = fallbackLogo;
              }}
            />
          </Navbar.Brand>
 
          <div className={`toggle-bar ${menuOpen ? 'active' : ''}`} onClick={handleToggle}>
            <span></span>
            <span></span>
            <span></span>
          </div>
 
          <Navbar.Collapse id="navbarCollapse" className={menuOpen ? 'show' : ''}>
            <Nav className="ms-auto p-4 p-lg-0 align-items-center">
              {isLoading ? (
                <Nav.Link>Loading...</Nav.Link>
              ) : (
                <>
                  {navbarData?.dataset?.data?.menus?.map((menu) => {
                    const path = menu.url;
 
                    if (menu.children && menu.children.length > 0) {
                      return (
                        <NavDropdown
                          key={menu.id}
                          title={menu.title}
                          id={`${menu.slug}-dropdown`}
                          menuVariant="light"
                        >
                          {menu.children.map((child) => (
                            <NavDropdown.Item key={child.id} as={Link} to={child.url}>
                              {child.title}
                            </NavDropdown.Item>
                          ))}
                        </NavDropdown>
                      );
                    }
 
                    if (menu.menu_type === 'button') {
                      return (
                        <a key={menu.id} href={menu.url} className="ms-lg-3">
                          <Button className="get-btn">{menu.title}</Button>
                        </a>
                      );
                    }
 
                    return (
                      <Nav.Link
                        key={menu.id}
                        as={Link}
                        to={path}
                        onClick={(e) => {
                          if (menu.url.includes('#')) {
                            const sectionId = menu.url.split('#')[1];
                            handleInPageLink(e, sectionId);
                          }
                        }}
                      >
                        {menu.title}
                      </Nav.Link>
                    );
                  })}
 
                  {/* Google Translate button at the end */}
                  <div className="ms-lg-3 translator">
                    <GoogleTranslate />
                  </div>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  );
};
 
export default Header;






